export default __webpack_public_path__ + "static/media/gold.c21fd6f5.svg";